import { render, staticRenderFns } from "./CreateCompetence.vue?vue&type=template&id=f5268a54&"
import script from "./CreateCompetence.vue?vue&type=script&lang=ts&"
export * from "./CreateCompetence.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCompetence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports